import React from 'react'

interface CircleIconProps {
  strokeColor?: string
  automatedTestId?: string
}

export const CircleIcon: React.FC<CircleIconProps> = (props) => (
    <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Site-Diagperm" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Site---Diag-360---Map-détail-filtre-ouvert-DO-TP" transform="translate(-235.000000, -264.000000)" stroke={props.strokeColor ?? "#76D19B" }strokeWidth="5">
                <g id="Filtres" transform="translate(80.000000, 185.000000)">
                    <g id="Déversement" transform="translate(20.000000, 52.000000)">
                        <circle cx="147.5" cy="39.5" r="10"></circle>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);